import React from 'react'
import DropdownMenu from 'dropdown-menu'
import { getValue } from 'firebase-utils'
import { Icon } from 'foundations-library/components'

const renderRegisteredOnColumn = (createdDate) => {
    const d = new Date(0)
    d.setUTCSeconds(createdDate)

    const year = d.toLocaleString('default', { year: 'numeric' })
    const month = d.toLocaleString('default', { month: '2-digit' })
    const day = d.toLocaleString('default', { day: '2-digit' })

    return `${year}-${month}-${day}`
}

const editDisabledHelper = (row, enrollmentEnabled) => {
    const isDeleted = row.deleted_at != null
    const disabled = isDeleted || !enrollmentEnabled

    return {
        editDisabled: disabled,
        editTooltip:
            disabled
                ? !enrollmentEnabled
                    ? getValue('sms_enrollment_feature_disabled_tooltip')
                    : isDeleted
                        ? getValue('sms_enrollment_enrollment_status_deleted_tooltip')
                        : null
                : null
    }
}

const optionsDropdownButton = (props) => {
    return (
        <div {...props}>
            <Icon name="more-vert" size={24} data-button="options" color={'#364047'} />
        </div>
    )
}

const renderOptionsColumn = (row, enrollmentEnabled, editEnabled, onClickPreview, additionalItemsCb) => {
    let menuItems: {
        text: string
        onClick: () => void
        disabled?: boolean
        tooltipText?: string | null
        color?: string
    }[] = []

    if (
        editEnabled ||
        (
            row.registration_status !== '' && !['pending-review', 'submitted', 'processing'].includes(row.registration_status)
        )
    ) {
        const { editDisabled, editTooltip } = editDisabledHelper(row, enrollmentEnabled)

        menuItems.push({
            text: 'Review/Edit',
            onClick: () => onClickPreview?.(row.csp_brand_id),
            disabled: editDisabled,
            tooltipText: editDisabled ? editTooltip : null
        })
    }

    const additionalItems = additionalItemsCb(row)

    if (additionalItems?.length) {
        menuItems = [...menuItems, ...additionalItems]
    }

    return menuItems.length > 0
        ? (
            <DropdownMenu
                button={optionsDropdownButton}
                menuItems={menuItems}
                dropdownStyle='configure'
            />
        )
        : <></>
}

const getErrorMessage = (err) => {
    const genericError = 'Something went wrong'
    try {
        // docs: https://docs.google.com/document/d/1sgnbuSRERxTCoWOpKEA1DQKOkibPTzQcVmnTLzKTyng/edit?tab=t.0#heading=h.f8c40c65r30e
        const error = err?.[0]
        if (error && error.code && error.description && error.fields?.length) {
            return `Invalid fields: ${error.fields.toString()}. Error: ${error.description}`
        }
        return genericError
    } catch (err) {
        console.log(err)
        return genericError
    }
}

export {
    getErrorMessage,
    renderRegisteredOnColumn,
    renderOptionsColumn
}